import request from "./request";
import { filterUndefindObj } from '@src/utils/dataHandlingFunc';

// 获取平台信息
export const getOperatorInfo = async () => {
  const res = await request({
    method: 'get',
    cancelOff: true,
    url: '/admin/operator/platformInfo',
  });

  console.log(res)

  return {
    darkLogo: res?.dark_logo ?? '',
    information: res?.information ?? '',
    lightLogo: res?.light_logo ?? '',
    companyLabel: res?.company_label ?? '',
    companyEmail: res?.company_email ?? '',
    companyAddress: res?.company_address ?? ''
  }
};

// 更新平台logo
export const editOperatorLogo = async ({
  logo,
  type,
  // information,
  companyLabel,
  companyEmail,
  companyAddr,
  lat,
  lng,
}) => {
  const newParams = filterUndefindObj({
    logo,
    logo_type: type,
    // information,
    label: companyLabel,
    company_email: companyEmail,
    company_address: companyAddr,
    lat,
    lng
  })

  const formData = new FormData();
  Object.keys(newParams).forEach(item => {
    formData.append(item, newParams[item]);
  })

  const res = await request({
    method: 'put',
    url: '/admin/operator/platformInfo',
    propsType: 'custom',
    data: formData
  });

  return !!res;
}